import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MarketingConfirmationModal = ({ showModal, closeModal, confirmationPrompt }) => {
  const { t } = useTranslation();
  return (
    <Modal show={showModal} className="font-poppins contact-preference-modal" centered>
      <Modal.Body className="modalBody mb-4">
        <div className="d-flex justify-content-end">
          <button type="button" className="close m-1" onClick={closeModal}>
            <span aria-hidden="true">×</span>
            <span className="sr-only">{t('profile.personalDetails.model.button.close')}</span>
          </button>
        </div>
        <div className="marketing-consent-title mb-2 mt-3">
          {' '}
          {t('referralPromotionPreference.marketingConsentModal.confirmationHeader')}
        </div>
        <p className="p-0 pt-2 marketing-preference-prompt">{confirmationPrompt}</p>
      </Modal.Body>
    </Modal>
  );
};

export default MarketingConfirmationModal;
